import { ComponentErrorBoundary, toCurrency, toFormattedDate, toFormattedRate } from '@app/utilities';
import { useEffect } from 'react';
import './OfferDetail.css';
import { Offer, useEndOffer, useGetMerchant, useRefreshOffers } from '@app/sdk';
import { addMilliseconds } from 'date-fns';
import { List } from 'semantic-ui-react';
import { Item } from '../../../shared/Item';

export function OfferDetails({ offer, refreshOffer }: { offer: Offer; refreshOffer: () => void }) {
  const { mutateAsync, isSuccess, isPending, error } = useEndOffer();
  const invalidateOffers = useRefreshOffers();
  async function endOffer() {
    await mutateAsync({
      offerId: offer.offerId,
      name: offer.name,
      endDate: addMilliseconds(new Date(), 500).toISOString(),
    });
    invalidateOffers();
  }

  useEffect(() => {
    if (isSuccess) {
      refreshOffer();
    }
  }, [isSuccess, refreshOffer]);

  return (
    <ComponentErrorBoundary>
      <div>
        {!offer ? (
          <div>Loading...</div>
        ) : (
          <div>
            <h1>{offer.name}</h1>
            <div className="ui grid">
              <div className="sixteen wide column">
                <div className="ui segment">
                  <div className="ui grid">
                    <div className="five wide column">
                      <div>
                        <strong>Type: </strong>
                        {offer.offerType} - {offer.termDuration} months
                      </div>
                    </div>
                    <div className="eleven wide column">
                      <div>
                        <strong>Rate: </strong>
                        {toFormattedRate(offer.rate?.value)}
                      </div>
                    </div>
                    <div className="five wide column">
                      <div>
                        <span className="offer-title">Risk Bands: </span>
                        <span>{offer.riskBands?.join(', ')}</span>
                      </div>
                    </div>
                    <div className="eleven wide column">
                      <div className="offer-title">Qualification</div>
                      <div className="four wide column">
                        <span className="offer-title">Minimum Amount: </span>
                        <span>{toCurrency(offer.qualification.minimumAmount)}</span>
                      </div>
                      <div className="four wide column">
                        <span className="offer-title">Maximum Amount: </span>
                        <span>{toCurrency(offer.qualification.maximumAmount)}</span>
                      </div>
                    </div>
                    <div className="five wide column">
                      <span className="offer-title">Status: </span>
                      <span>{offer.status}</span>
                    </div>
                    <div className="five wide column">
                      <span className="offer-title">Start Date: </span>
                      <span>{toFormattedDate(offer.startDate)}</span>
                    </div>
                    <div className="five wide column">
                      <span className="offer-title">End Date: </span>
                      <span>{toFormattedDate(offer.endDate)}</span>
                    </div>
                    <div className="sixteen wide column">
                      <span className="offer-title">Description: </span>
                      <span>{offer.description}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="ui grid">
              <div className="sixteen wide column">
                <div className="ui segment">
                  <h4 className="ui header">Merchants</h4>
                  <div className="ui list">
                    {offer.merchantIds?.length > 0 ? (
                      offer.merchantIds?.map((merchantId, index) => (
                        <div className="item" key={index}>
                          <Merchant id={merchantId} />
                        </div>
                      ))
                    ) : (
                      <div>No Linked Merchants</div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <button className="ui primary button" style={{ margin: '10px' }} onClick={() => endOffer()} disabled>
              End Offer Now
            </button>
            {isPending && <div className="ui active inline loader"></div>}
            {error && <div>{JSON.stringify(error)}</div>}
          </div>
        )}
      </div>
    </ComponentErrorBoundary>
  );
}

function Merchant({ id }: { id: string }) {
  const { data: merchant } = useGetMerchant({ id });
  return (
    <div>
      {merchant && (
        <List>
          <Item header={'Name:'} description={merchant?.name} />
          <Item header={'Organisation Unit:'} description={merchant.organisationUnitId} />
        </List>
      )}
    </div>
  );
}
